export default "__VITE_ASSET__3a97c3d6__"